import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarBandejaAutorizacion } from "../services/bandeja-service";

/**
 * Polling de 5s · suficiente para que un autorizador note una nueva solicitud sin
 * pegarle al server cada segundo. El loader del route precarga el primer fetch.
 *
 * Los filtros de columna y el paginado van al server como query params y forman
 * parte del queryKey (refetch al cambiar). Usamos `useQuery` + `keepPreviousData`
 * (en vez de `useSuspenseQuery`) para que, al cambiar el filtro o la página, NO
 * re-suspenda y parpadee: se mantienen las filas previas mientras llega el set.
 */
const REFETCH_INTERVAL_MS = 5_000;

/** Tamaño de página compartido entre la page y el loader del route (misma queryKey). */
export const BANDEJA_PAGE_SIZE = 15;

export const bandejaAutorizacionQueryOptions = (
  params: Record<string, string | number> = { page: 1, pageSize: BANDEJA_PAGE_SIZE },
) =>
  queryOptions({
    queryKey: [...qk.bandejaAutorizacion, params] as const,
    queryFn: () => listarBandejaAutorizacion(params),
    refetchInterval: REFETCH_INTERVAL_MS,
    placeholderData: keepPreviousData,
  });

export const useBandejaAutorizacion = (
  params: Record<string, string | number> = { page: 1, pageSize: BANDEJA_PAGE_SIZE },
) => useQuery(bandejaAutorizacionQueryOptions(params));
